import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M3.75 3.75h7.42l9.93 9.93c.86.86.86 2.25 0 3.11l-4.31 4.31c-.86.86-2.25.86-3.11 0l-9.93-9.93V3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9 11.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5z"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M3.75 3.75h7.42l9.93 9.93c.86.86.86 2.25 0 3.11l-4.31 4.31c-.86.86-2.25.86-3.11 0l-9.93-9.93V3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9 11.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5z"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M7.5 7.5h14.84L42.2 27.36a4.394 4.394 0 010 6.22l-8.62 8.62a4.394 4.394 0 01-6.22 0L7.5 22.34V7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M18 22.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9z"
  }))
};
export var Tag = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});